<template>
    <footer v-if="!$route.path.includes('sessions') && !$route.path.includes('register')"
        class="bg-white border-t border-slate-200 py-5 text-xs text-slate-400 mt-auto">
        <div class="max-w-[1640px] mx-auto px-4 lg:px-8 text-left">
            <div class="flex items-center gap-2 mb-2">
                <span class="font-bold text-slate-700">VGC</span>
                <span>© 2026 VGC. All Rights Reserved.</span>
            </div>
            <p class="mb-0 leading-relaxed">{{ $t('footer_text') }}</p>
        </div>
    </footer>
</template>
<script>
export default {}
</script>
